import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	chip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[400]),
		borderRadius: 3,
		color: colors.gray[50],
		fontWeight: 700,
		fontSize: 14,
		margin: theme.spacing(0, 0.5),
		height: "unset",
		"& > *": {
			padding: theme.spacing(0.5, 1)
		}
	},
	text: {
		color: colors.blue[400]
	}
}))

export default useStyles
